import requestUtil from '../../helpers/requestUtil';
import { setLoading } from '../common/Loader/slice';
import { resetError, setChat, setError, setLodingFlagDecrement, setLodingFlagIncrement, setMessages, setMsgSendFlag, setParams,setTotalCount } from './slice';
import * as Toasts from '../common/Toastify';

export function resetErrorStatus() {
    return async dispatch => {
        dispatch(resetError());
    };
}

export function getNotificationData({ url, params }) {
    return async dispatch => {
      dispatch(setLodingFlagIncrement());
        try {
            const response = await requestUtil(`${url}`, 'POST', { ...params });
            dispatch(setMessages(response.employerMessages));
            dispatch(setTotalCount(response.totalCount));
        } catch (error) {
            dispatch(setError(error.message))
        }
        finally {
            dispatch(setLodingFlagDecrement())
        }
    };
}

export const updateParams = (data) => {
    return async dispatch => {
        dispatch(setParams(data));
    };
}

export const getPersonalMsg = ({ url, params }) => {
    return async dispatch => {
      dispatch(setLodingFlagIncrement());
        try {
            const response = await requestUtil(`${url}`, 'POST', { ...params });
            dispatch(setChat(response.appMessages));
        } catch (error) {
            dispatch(setError(error.message))
        }
        finally {
            dispatch(setLodingFlagDecrement())
        }
    }
}

export const sendPersonal = ({ url, params }) => {
    return async dispatch => {
      dispatch(setLodingFlagIncrement());
        try {
            const response = await requestUtil(`${url}`, 'POST', { ...params });
            dispatch(setMsgSendFlag(true));
        } catch (error) {
            dispatch(setMsgSendFlag(false))
            dispatch(setError(error.message))
        }
        finally {
            dispatch(setLodingFlagDecrement())
        }
    }
}

export const updateMsgFlag = (flag) => {
    return async dispatch => {
        dispatch(setMsgSendFlag(flag));
    }
}


export const deleteNotificationData = ({url,notificationId, candidateUniqueId}) => {
    return async (dispatch,getState) => {
      dispatch(setLodingFlagIncrement());
      const state = getState();
      const {data} = state.notifications;
      const newNotificationData = JSON.parse(JSON.stringify(data));
    try {
        const response = await requestUtil(`${url}/Messages/Delete-AppMessage-Details-By-Id?AppMessageId=${notificationId}&CandidateUniqueId=${candidateUniqueId}`, 'DELETE');
       if(response){
        const updateNotificationData = newNotificationData.filter( notificationData => notificationData?.messageId !== notificationId)
        dispatch(setMessages(updateNotificationData));
        Toasts.success(response.message)
       }
    } catch (error) {
        dispatch(setError(error.message))
        Toasts.error(error.message)
    }
    finally {
        dispatch(setLodingFlagDecrement())
    }
}
}

export const updateNotificationStatus = ({url,notificationStatusParams}) => {
    return async (dispatch,getState) => {
        dispatch(setLodingFlagIncrement());
        const state = getState()
        const {isMessageRead,messageId} = notificationStatusParams
        const {data} = state.notifications;
        const newNotificationData = JSON.parse(JSON.stringify(data));
        try {
            const response = await requestUtil(`${url}/Messages/MarkMessageAsRead`,'POST', { ...notificationStatusParams });
        // dispatch(setMessages(response.candidateMessages));
            if(response){
                const updateNotificationData = newNotificationData?.map(item => {
                    if(item?.messageId === messageId){
                        return {...item,isMessageRead:isMessageRead}
                    }
                    return item
                })
                dispatch(setMessages(updateNotificationData));
            }
        } catch (error) {
            dispatch(setError(error.message))
            Toasts.error(error.message)
        }
        finally {
            dispatch(setLodingFlagDecrement())
        }
    }
}




export const updateArchiveStatus = ({url,notificationStatusParams}) => {
    return async (dispatch,getState) => {
        dispatch(setLodingFlagIncrement());
        const state = getState()
        const {isArchived,messageId} = notificationStatusParams
        const {data} = state.notifications;
        const newNotificationData = JSON.parse(JSON.stringify(data));
        try {
            const response = await requestUtil(`${url}/Messages/archive-for-notification-messages`,'POST', { ...notificationStatusParams });
        // dispatch(setMessages(response.candidateMessages));
            // if(response){
            //     const updateNotificationData = newNotificationData?.map(item => {
            //         if(item?.messageId === messageId){
            //             return {...item,isArchived:isArchived}
            //         }
            //         return item
            //     })
            //     dispatch(setMessages(updateNotificationData));
            // }


            if(response?.result){
                const updateNotificationData = newNotificationData?.filter(data => data?.messageId !== messageId);
                dispatch(setMessages(updateNotificationData));
                Toasts.success(response.message)
            }

        } catch (error) {
            dispatch(setError(error.message))
            Toasts.error(error.message)
        }
        finally {
            dispatch(setLodingFlagDecrement())
        }
    }
}